/* istanbul ignore file */
import React from 'react';
import VacanciesBreadcrumbs from 'domain/recruiting/vacancy/shared/VacanciesBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useVacancyUrl } from 'domain/recruiting/vacancy/vacancyRoute';
import { useParams } from 'react-router-dom';

const SingleVacanciesBreadcrumbs = ({ children = null }: { children?: React.ReactNode | React.ReactNode[] | null }) => {
  const { getSingleEntityUrl } = useVacancyUrl();
  // @ts-ignore
  const { id } = useParams<Dictionary<string>>();

  return (
    <VacanciesBreadcrumbs>
      <SingleBreadcrumbItem entity={id!} link={getSingleEntityUrl(id)} />
      {children}
    </VacanciesBreadcrumbs>
  );
};

export default SingleVacanciesBreadcrumbs;
